import flow from 'lodash/flow';

export type MigrationFn<T, T2> = (data: T) => T2;

// TODO(IL, 2024-09-10): would be nice to have avoid the any-types, but I
// can't figure out [T -> T2, T2 -> T3, T3 -> T4, ...] generic typing chain.
// We will probably reimplement this in Python soon anyway x.x

/** Run necessary migrations to get from a given version to the latest version. */
export function runMigrationChain<
  DataType extends any,
  MigrationFinal extends any
>({
  version,
  data,
  migrationChain,
}: {
  version: number;
  data: DataType;
  migrationChain: ReadonlyArray<MigrationFn<any, any>>;
}): MigrationFinal {
  // assumes migration number is integer and indicies of migrationChain correspond to that migration version number
  const latestMigrationVersion = migrationChain.length;

  if (!Number.isFinite(version) || version > latestMigrationVersion) {
    throw new Error(`unsupported migration version "${version}"`);
  }

  if (version === latestMigrationVersion) {
    // already is latest, no migration needed
    return data as unknown as MigrationFinal;
  }

  const migrationsToRun = migrationChain.slice(version);

  return flow(migrationsToRun)(data);
}
